import { createMapper, Module, Mutations } from 'vuex-smart-module'

class CttState {
  chosenAuthors: any[] = []
}

class CttMutations extends Mutations<CttState> {
  setChosenAuthors(authors: any[]) {
    this.state.chosenAuthors = authors
  }
}

export const ctt = new Module({
  state: CttState,
  mutations: CttMutations
})

export const cttMapper = createMapper(ctt)
